<template>
  <div class="px-5">
    <div v-for="(val , index) in valData" :key="index">

      <collapse class="show w-100 mb-3" :selected="false">
        <div slot="collapse-header">
          محتوای {{index + 1}}
        </div>
        <div slot="collapse-body">
          <div class="form-row justify-content-between align-items-center">
            <div class="col-12 col-md-4">
              <div class="form-group text-right">
                <label :for="'type' + index">نوع</label>
                <fvSelect :id="'type' + index" class="form-control select text-right fv-size-md"
                          v-model="valData[index].type"
                          :options="typeOption"
                />
              </div>
            </div>
            <div class="col-auto">
              <button type="button" @click.prevent="valData.splice(index, 1)" class="btn btn-outline-danger">
                پاک کردن
                <i class="fa fa-trash"/>
              </button>
            </div>
            <div v-if="valData[index].type === 'HTML'" class="col-12">
              <label :for=" + index">متن</label>
              <appTextEditor v-model="valData[index].HTML" :id="'html'+index" placeholder="متن"/>
            </div>
            <div v-if="valData[index].type === 'MEDIUM'" class="col-12">
              <label :for="'image' + index">عکس</label>
              <appFileUploader :id="'image' + index" v-model="valData[index].medium"/>
            </div>
          </div>
        </div>

      </collapse>
    </div>
    <hr>
    <button type="button" @click="valData.push({type: undefined})" class="btn btn-outline-primary float-left">
      اضافه کردن
      <i class="fas fa-plus" />
    </button>
  </div>

</template>

<script>

  import appTextEditor from "./appTextEditor";
  import appFileUploader from "./appFileUploader";
  import Collapse from 'vue-collapse'

  export default {
    components: {
      appTextEditor,
      appFileUploader,
      Collapse
    },
    props: {
      placeholder: {
        type: String
      },
      id: {
        type: String
      },
      value: {
        type: Array,
        default: []
      },
      required: [Boolean, Function],
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        typeOption: [{text: 'متن', value: 'HTML'}, {text: 'عکس', value: 'MEDIUM'}]
      }
    },
    computed: {
      valData: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
  }
</script>

<style lang="scss">
</style>
